/**
 * @param {string} originalUrl - 原始的OSS图片URL
 * @returns {string} 处理后的URL，若入参无效则返回空字符串
 */
export function formatOssImageUrl(originalUrl) {
    //非字符串/空值直接返回空
    if (typeof originalUrl !== 'string' || originalUrl.trim() === '') {
      return '';
    }
    let newUrl = originalUrl;
    // 将http协议替换为https
    newUrl = newUrl.replace(/^http:\/\//, 'https://');
    // 移除URL中所有的internal字符串（全局匹配）
    newUrl = newUrl.replace(/-internal/g, '');
    return newUrl;
  }